import { useState } from 'react';
import { usePWAInstall } from '../utils/usePWAInstall';
import { useLanguage } from '../context/LanguageContext';

function InstallPWA() {
  const { canInstall, isIOS, isInStandalone, installed, install } = usePWAInstall();
  const [iosDismissed, setIosDismissed] = useState(false);
  const { t } = useLanguage();

  if (/windows/i.test(navigator.userAgent)) return null;
  if (isInStandalone || installed) return null;

  if (canInstall) {
    return (
      <div
        className="d-flex align-items-center justify-content-between mx-auto mt-3 px-3 py-2 rounded-3 shadow-sm bg-white"
        style={{ maxWidth: "500px", border: "1px solid #f0d0d0" }}
      >
        <div className="d-flex align-items-center gap-2">
          <i className="bi bi-phone-fill text-danger fs-5"></i>
          <div>
            <div className="fw-semibold small">{t("pwa.installTitle")}</div>
            <div className="text-muted" style={{ fontSize: "0.75rem" }}>
              {t("pwa.installSubtitle")}
            </div>
          </div>
        </div>
        <button
          className="btn btn-sm btn-danger rounded-pill px-3"
          onClick={install}
        >
          <i className="bi bi-download me-1"></i>{t("pwa.install")}
        </button>
      </div>
    );
  }

  if (isIOS && !iosDismissed) {
    return (
      <div
        className="mx-auto mt-3 px-3 py-2 rounded-3 shadow-sm bg-white position-relative"
        style={{ maxWidth: "500px", border: "1px solid #f0d0d0" }}
      >
        <button
          type="button"
          className="btn-close position-absolute"
          style={{ top: "8px", right: "10px", fontSize: "0.6rem" }}
          onClick={() => setIosDismissed(true)}
        />
        <div className="d-flex align-items-center gap-2 mb-1">
          <i className="bi bi-phone-fill text-danger fs-5"></i>
          <span className="fw-semibold small">{t("pwa.iosTitle")}</span>
        </div>
        <div className="text-muted" style={{ fontSize: "0.78rem" }}>
          {t("pwa.iosHint")}
        </div>
      </div>
    );
  }

  return null;
}

export default InstallPWA;
